import BaseEntityDto from "@/models/Shared/BaseEntityDto";
import UserDto from "../Users/UserDto";

export default class BaseAgencyScopeEntityDto extends BaseEntityDto {
    agencyId: string;
    createdBy: UserDto = new UserDto();
    createdAt: Date = new Date();
    updatedBy: UserDto = new UserDto();
    updatedAt: Date = new Date();
}